export enum EExportType {
    EXCEL = 'EXCEL',
    PDF = 'PDF'
}